module.exports = __webpack_public_path__ + "static/media/DINOT-Regular.d77de515.woff2";